'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var aviaryTokens = require('aviary-tokens');
var reactFontawesome = require('../../../react-fontawesome/react-fontawesome.cjs');
var Tooltip_web = require('../Tooltip/Tooltip.web.cjs');
var Pill_web_styles = require('./Pill.web.styles.cjs');

/**
 * Small rounded pill component, used to display information in a small space
 *
 * @scope: Core
 *
 */ const Pill = ({ backgroundColor = "success", size = "medium", icon, svgUrl, iconLocation = "start", labelContent, tooltipContent, customCss, ...rest })=>{
    const currentTheme = react.useTheme();
    const themeColors = aviaryTokens.colorProfileMapper(currentTheme);
    const isDarkMode = currentTheme.theme === "dark";
    const isAccent = backgroundColor === "sand" || backgroundColor === "forest";
    const pillStyles = [
        Pill_web_styles.pillBase,
        isAccent && Pill_web_styles.accentThemedStyles(backgroundColor),
        !isAccent && Pill_web_styles.themedStyles(themeColors[backgroundColor]),
        size && Pill_web_styles.size[size],
        customCss
    ];
    const renderIconOrSvg = (location)=>{
        if (!svgUrl && !icon || location !== iconLocation) return;
        if (icon) {
            return /*#__PURE__*/ jsxRuntime.jsx("div", {
                css: [
                    icon && Pill_web_styles.icon[iconLocation](size)
                ],
                "data-testid": "pill-icon",
                children: /*#__PURE__*/ jsxRuntime.jsx(reactFontawesome.FontAwesomeIcon, {
                    icon: icon
                })
            });
        }
        if (svgUrl?.darkMode && isDarkMode) {
            return /*#__PURE__*/ jsxRuntime.jsx("img", {
                src: svgUrl.darkMode,
                css: [
                    Pill_web_styles.icon[iconLocation](size),
                    Pill_web_styles.svg
                ],
                role: "none"
            });
        }
        return /*#__PURE__*/ jsxRuntime.jsx("img", {
            src: svgUrl?.lightMode,
            css: [
                Pill_web_styles.icon[iconLocation](size),
                Pill_web_styles.svg
            ],
            role: "none"
        });
    };
    return /*#__PURE__*/ jsxRuntime.jsx(Tooltip_web.Tooltip, {
        tooltipContent: tooltipContent ? tooltipContent : "",
        isTooltipHidden: !tooltipContent,
        children: /*#__PURE__*/ jsxRuntime.jsxs("div", {
            css: pillStyles,
            role: "note",
            "aria-label": labelContent,
            ...rest,
            children: [
                renderIconOrSvg("start"),
                labelContent,
                renderIconOrSvg("end")
            ]
        })
    });
};

exports.Pill = Pill;
//# sourceMappingURL=Pill.web.cjs.map
